// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_MQw","productName":"Table_productName__2vtBS"};